import React, { useContext, useEffect, useRef, useState } from "react"
import useDebounce from "../../../../hooks/use-debounce"
import constants from "../../../../services/constants_fhaa"
import TextField from "../../../common/form/text-field/text-field"
import { LocationContext } from "../../../common/location-provider/location-provider"
import asSearchFilter from "../as-search-filter/as-search-filter"

const coerceSearchTextValue = v => {
  if (v === null || v === undefined) {
    return ""
  }
  if (typeof v === "string") {
    return v
  }
  return String(v)
}

const SearchText = asSearchFilter(
  ({
    placeholder,
    fieldName,
    multiFieldNames,
    setValue,
    setQuery,
    value,
    componentid,
    formInstance,
    queryType,
    commitOnEnter = false,
    ...rest
  }) => {
    const state = useContext(LocationContext)
    const lastParentQueryRef = useRef()

    const [curText, setCurText] = useState(() => coerceSearchTextValue(value))
    const debouncedText = useDebounce(curText, constants.searchDebounce)

    useEffect(() => {
      setCurText(coerceSearchTextValue(value))
    }, [value])

    useEffect(() => {
      if (!commitOnEnter) {
        return
      }
      const coerced = coerceSearchTextValue(value)
      if (lastParentQueryRef.current === coerced) {
        return
      }
      lastParentQueryRef.current = coerced
      setValue(coerced)
    }, [value, commitOnEnter])

    useEffect(() => {
      if (!commitOnEnter) {
        setValue(debouncedText)
      }
    }, [debouncedText, commitOnEnter])

    useEffect(() => handleState(), [state])

    const handleState = () => {
      if (!state) {
        return
      }
      let stateField = fieldName
      if (state.useComponentId) {
        if (state.useComponentId) {
          stateField = componentid
        }
      }
      const newValueObj =
        state && state[stateField] ? state[stateField] : { value: "" }
      let newValue = newValueObj.value
      if (!newValue) {
        return
      }

      console.log("handleState search-text state - query value:", newValue)
      setCurText(newValue)
      if (commitOnEnter) {
        setValue(newValue)
      }
    }

    return (
      <TextField
        field={fieldName}
        value={curText || ""}
        onChange={e => setCurText(e.target.value)}
        placeholder={placeholder || "Search"}
        {...rest}
        onKeyDown={e => {
          rest.onKeyDown?.(e)
          if (commitOnEnter && e.key === "Enter") {
            e.preventDefault()
            setValue(curText ?? "")
          }
        }}
      />
    )
  }
)

export default SearchText
